import { WarningTwoIcon } from '@chakra-ui/icons';
import { VscCircleFilled } from 'react-icons/vsc';
import { isSuitableIntegration as isSuitableGoogleIntegration } from '@/features/interactions/addToGoogle/calendar.lib';
import { isSuitableIntegration as isSuitableOutlookIntegration } from '@/features/interactions/addToOutlook/calendar.lib';
import type { DecoratedIntegration } from '@/pages/Schedule/hooks/useIntegrations';
import { IntegrationType } from '@/types/gql.generated';
import { Badge, Flex, Icon, Text, Tooltip } from '@/ui';
import { ReconnectButton } from './ReconnectButton';

type Props = {
  integration: DecoratedIntegration;
};

export const MagicControl = ({ integration }: Props) => {
  const isOutlook = integration.type === IntegrationType.OutlookCalendar;
  const providerName = isOutlook ? 'Outlook' : 'Google';
  const isSuitable = isOutlook
    ? isSuitableOutlookIntegration(integration)
    : isSuitableGoogleIntegration(integration);

  if (!isSuitable) {
    return (
      <Flex align="center" as="span" gap="2">
        <Tooltip
          label={`We aren't able to send events to this ${providerName} calendar. Please click "Enable Magic" to reconnect this ${providerName} account.`}
        >
          <WarningTwoIcon color="red.600" />
        </Tooltip>
        <ReconnectButton integration={integration} />
      </Flex>
    );
  }
  return (
    <Tooltip label="Events imported from Magic can be sent directly to calendars in this account">
      <Badge
        alignItems="center"
        colorScheme="blackAlpha"
        cursor="help"
        display="flex"
        gap="1"
      >
        <Icon as={VscCircleFilled} boxSize="20px" color="green.300" />
        <Text as="span">Magic On</Text>
      </Badge>
    </Tooltip>
  );
};
